import { useQuery } from '@tanstack/react-query';
import { getDownloadUrl } from '@services/api/fileManagementApi';
import QueryKeys from '@constants/queryKeys';
import { FolderDesignationEnum } from '@th-types/uploadImage.type';

const PRESIGNED_URL_STALE_MS = 8 * 60 * 1000;

/** Presigned GET URL for a worker personal video. */
export function usePersonalVideoUrl(s3FileId: number | null | undefined) {
  return useQuery({
    queryKey: [QueryKeys.WORKER_PERSONAL_VIDEO_DOWNLOAD_URL, s3FileId],
    queryFn: () =>
      getDownloadUrl(
        s3FileId as number,
        FolderDesignationEnum.PERSON_PERSONAL_VIDEO
      ),
    enabled: !!s3FileId,
    staleTime: PRESIGNED_URL_STALE_MS,
  });
}

export default usePersonalVideoUrl;
